import { Component, AfterViewInit, OnInit, ChangeDetectorRef } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { MdSnackBar } from '@angular/material';

import { TdLoadingService, TdDialogService, TdMediaService } from '@covalent/core';

import { UserService } from '../users/services/user.service';
import { ClientService } from '../clients/services/client.service';
import {TokensService} from '../services';

import 'rxjs/add/operator/toPromise'; 

@Component({
  selector: 'tokens',
  providers: [UserService, ClientService, TokensService],
  templateUrl: './tokens.component.html',
  styleUrls: ['./tokens.component.scss'],
})
export class TokensComponent implements AfterViewInit, OnInit {

  tokens: any[];
  filteredTokens: any[];

  api: string;
  valid: string;
  filterTitle: string;
  filterString: string = '';

  constructor(private _titleService: Title,
              private _loadingService: TdLoadingService,
              private _dialogService: TdDialogService,
              private _snackBarService: MdSnackBar,
              private _userService: UserService,
              private _clientService: ClientService,
              private _tokenService: TokensService,
              private _changeDetectorRef: ChangeDetectorRef,
              public media: TdMediaService) {
  }

  ngOnInit(): void {
    this._titleService.setTitle('Token');
    this.load();
  }

  loadFilter(api: string, valid: string, filterTitle: string) {
    this.api = api;
    this.valid = valid;
    this.filterTitle = filterTitle;
    this.filterTokens(this.filterString);
  }  

  ngAfterViewInit(): void {
    // broadcast to all listener observables when loading the page
    this.media.broadcast();
    // force a new change detection cycle since change detections
    // have finished when `ngAfterViewInit` is executed
    this._changeDetectorRef.detectChanges();
  } 

  filterTokens(value: string = ''): void {
    this.filterString = value;
    this.filteredTokens = this.tokens.filter((token: any) => {
      if (this.valid!=null && this.valid!=token.valid.toString()) {
        return false;
      }
      if (this.api!=null && this.api!=token.apiToken.toString()) {
        return false;
      }
      return token.value.toLowerCase().indexOf(value.toLowerCase()) > -1 ||
          token.clientname.toLowerCase().indexOf(value.toLowerCase()) > -1 ||
          token.username.toLowerCase().indexOf(value.toLowerCase()) > -1;
    });
  }

  async load(): Promise<void> {
    try {
      this._loadingService.register('tokens.list');
      this.tokens = await this._tokenService.getTokens().toPromise();
      this.loadFilter(null, null, "Alle Tokens");
    } catch (error) {
      
    } finally {
      this.filteredTokens = Object.assign([], this.tokens);
      this._loadingService.resolve('tokens.list');
    }
  }

  delete(guid: string): void {
    this._dialogService
      .openConfirm({message: 'Are you sure you want to delete this token?'})
      .afterClosed().toPromise().then((confirm: boolean) => {
        if (confirm) {
          this._delete(guid);
        }
      });
  }

  private async _delete(guid: string): Promise<void> {
    try {
      this._loadingService.register('tokens.list');
      await this._tokenService.deleteToken(guid).toPromise();
      this.load();
      this._snackBarService.open('Token gelöscht', 'Ok');
    } catch (error) {
      this._dialogService.openAlert({message: 'There was an error trying to delete the token'});
    } finally {
      this._loadingService.resolve('tokens.list');
    }
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/_storageApp.Front.release/src/app/tokens/tokens.component.ts